import NumeralInput from './NumeralInput'
import SearchInput from './SearchInput'
import DefaultInput from './DefaultInput'
import AutocomplateInput from './AutocomplateInput'
import CreditCardInput from './CreditCardInput'
import PhoneNumberInput from './PhoneNumberInput'
import RangeInput from './RangeInput'
// import DatePickerInput from './DatePickerInput'
import RichTextInput from './RichTextInput'

const Numeral = NumeralInput
const Search = SearchInput
const Default = DefaultInput
const Autocomplate = AutocomplateInput
const CreditCard = CreditCardInput
const PhoneNumber = PhoneNumberInput
const Range = RangeInput
const RichTextArea = RichTextInput
// const DatePicker = DatePickerInput

export default { Numeral, Search, Default, Autocomplate, CreditCard, PhoneNumber, Range, RichTextArea }
// export default { Numeral, Search, Default, Autocomplate, CreditCard, PhoneNumber, DatePicker }
